import * as React from 'react';
import ColorScheme, { colorSchemeToCss } from 'owa-color-utils/lib/ColorScheme';
import { getCalendarEntry, CalendarId } from 'owa-calendar-cache';
import { IButtonProps, IconButton } from '@fluentui/react/lib/Button';
import { observer } from 'mobx-react-lite';

let styles = require('./CalendarBar.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CalendarBarProps extends React.HTMLProps<HTMLDivElement> {
    calendarId: CalendarId;
    calendarColorScheme: ColorScheme;
    hideCalendarName?: boolean;
    schedulingAssistantHeader?: string;
    buttonProps?: IButtonProps[];
}

const CalendarBar = observer(function CalendarBar(props: CalendarBarProps) {
    const {
        hideCalendarName,
        schedulingAssistantHeader,
        calendarId,
        calendarColorScheme,
        buttonProps,
        ...divProps
    } = props;
    let calendarColorStyle = colorSchemeToCss(calendarColorScheme);
    // Work Item 58585: Clean code once the teams/channels are added to the cache
    let calendarName = calendarId ? getCalendarEntry({ id: calendarId }).CalendarName : '';
    return (
        <div
            {...divProps}
            style={{ backgroundColor: calendarColorStyle.backgroundColor }}
            className={classNames(styles.calendarBar, divProps.className)}>
            {schedulingAssistantHeader ? (
                <span
                    style={{ color: calendarColorStyle.color }}
                    className={styles.calendarBarText}>
                    {schedulingAssistantHeader}
                </span>
            ) : hideCalendarName ? null : (
                <span
                    style={{ color: calendarColorStyle.color }}
                    className={styles.calendarBarText}>
                    {calendarName}
                </span>
            )}
            <span className={styles.calendarBarFiller} />
            {buttonProps &&
                buttonProps.map(button => (
                    <IconButton
                        {...button}
                        key={button.iconProps!.iconName}
                        className={classNames(styles.calendarBarIcon, button.className)}
                    />
                ))}
        </div>
    );
});
export default CalendarBar;
